<template>
	<section>
		<div style="padding-top: 10px">
			<el-button size="mini" @click="handleAddDialogForm()">{{ $t("productSpecification.addTo") }}</el-button>
			<el-input style="width: 200px; float: right" clearable v-model="keyword" size="mini" :placeholder="$t('productSpecification.nameSearch')" />
		</div>

		<!-- 表格 -->
		<el-table
			ref="dragTable"
			:data="filterSepcifications"
			style="width: 100%"
			row-key="id"
		>
			<!-- 拖拽列 -->
			<el-table-column width="60" label="">
				<template slot-scope="scope">
					<div class="drag-handle">
						<i class="el-icon-rank"></i>
					</div>
				</template>
			</el-table-column>

			<el-table-column prop="name" :label="$t('productSpecification.specificationName')"> </el-table-column>
			<el-table-column prop="cz" :label="$t('productSpecification.operate')">
				<template slot-scope="scope">
					<el-button size="mini" @click="handleEditDialogForm(scope.$index, scope.row)">{{ $t("productSpecification.edit") }}</el-button>
					<el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">{{ $t("common.delete") }}</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 添加规格弹出框 -->
		<AddSpecification
			:addDialogFormVisible="addDialogFormVisible"
			@handle-add-cancel="handleAddCancel"
			@handle-update-specification="handleUpdateSpecification"
		></AddSpecification>

		<!--编辑规格弹出框-->
		<el-dialog :title="$t('productSpecification.editSpecifications')" :visible.sync="editDialogFormVisible" width="30%" :close-on-click-modal="false">
			<el-form ref="editDialogForm" :rules="formRules" :model="editDialogForm">
				<el-form-item :label="$t('productSpecification.specificationName')" prop="name">
					<el-input v-model="editDialogForm.name" :disabled="true"></el-input>
				</el-form-item>
				<el-form-item :label="$t('productSpecification.attributes')" prop="options">
					<div class="table-caption">
						<el-button size="mini" type="primary" @click="handleEditAddOptions()">{{ $t("productSpecification.addTo") }}</el-button>
					</div>
					<el-table style="width: 100%" :data="this.editDialogForm.options" :empty-text="$t('productSpecification.addAttributes')" size="mini">
						<el-table-column prop="name" :label="$t('productSpecification.name')"> </el-table-column>
						<el-table-column prop="actions" :label="$t('productSpecification.operate')">
							<template slot-scope="scope">
								<el-button size="mini" type="danger" @click="handleEditDeleteOptions(scope.$index)">{{ $t("common.delete") }}</el-button>
							</template>
						</el-table-column>
					</el-table>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleEditCancel()">{{ $t("common.cancel") }}</el-button>
				<el-button type="primary" @click="handleEditConfirm()">{{ $t("common.sure") }}</el-button>
			</span>
		</el-dialog>

		<!-- 编辑添加规格options弹出框 -->
		<el-dialog :title="$t('common.options')" :visible.sync="editAddOptionsFormVisible" width="30%" :close-on-click-modal="false">
			<p>{{ $t("common.option") }}</p>
			<el-input v-model="editOptionsName" :placeholder="$t('productSpecification.optionName')" clearable></el-input>
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleEditAddOptionsCancel()">{{ $t("common.cancel") }}</el-button>
				<el-button type="primary" @click="handleEditAddOptionsConfirm()">{{ $t("common.sure") }}</el-button>
			</span>
		</el-dialog>
	</section>
</template>
<script>
import Sortable from "sortablejs";
import {
	deleteCustomerAttributes,
	getCustomerAttributesDetails,
	putCustomerAttributesUpdate,
    updateCustomerAttributesSort
} from "@/services/api-v2/api-v2";

import AddSpecification from "./add-specification.vue";

export default {
	components: {
		AddSpecification,
	},

	props: {
		sepcifications: {
			type: Array,
			required: true,
			default: null,
		},
	},

	data() {
		return {
            // 搜索关键词
			keyword: "",

            // 添加规格弹出框
			addDialogFormVisible: false,

            // 添加规格options弹出框
			addOptionsFormVisible: false,

            // 添加规格options名称
			optionsName: "",

			sortable: null,

			originOrder: [],

            // 规格表单验证
			formRules: {
				name: [
					{
						required: true,
						message: this.$t(
							"productSpecification.enterSpecificationName"
						),
						trigger: "blur",
					},
				],
				options: [
					{
						required: true,
						message: this.$t(
							"productSpecification.addOptions"
						),
						trigger: "blur",
					},
				],
			},

        	// 规格编辑弹出框
			editDialogFormVisible: false,

            // 规格编辑时表单值
			editDialogForm: {
				name: "",
				id: "",
				options: [],
				index: "",
			},

            // 编辑添加规格options名称
			editOptionsName: "",

            // 编辑添加options弹出框
			editAddOptionsFormVisible: false,
            hasShownSortWarning: false
		};
	},

	computed: {
		filterSepcifications() {
			if (this.keyword) {
				return this.sepcifications.filter((data) => {
					return (
						data.name &&
						data.name
							.toLowerCase()
							.includes(this.keyword.toLowerCase())
					);
				});
			}

			return this.sepcifications;
		},
	},

	mounted() {
		this.initRowDrag();
	},

	methods: {
		initRowDrag() {
			this.$nextTick(() => {
				const tbody =
					this.$refs.dragTable.$el.querySelector(
						".el-table__body-wrapper tbody"
					);

				if (!tbody) return;

				this.sortable = Sortable.create(tbody, {
					handle: ".drag-handle",
					animation: 150,

                    onMove: () => {
                       if (this.keyword) {
                            if (!this.hasShownSortWarning) {
                                this.hasShownSortWarning = true;

                                this.$message.warning(
                                    this.$t(
                                        "productSpecification.cannotSortWhenSearching"
                                    )
                                );
                                setTimeout(() => {
                                    this.hasShownSortWarning = false;
                                }, 1000);
                            }

                            return false;
                        }
                        return true;
                    },
					onStart: () => {
						this.originOrder = [...this.sepcifications];
					},

					onEnd: async ({ oldIndex, newIndex }) => {
						if (oldIndex === newIndex) return;



						const list = [...this.sepcifications];

						const movedItem = list.splice(
							oldIndex,
							1
						)[0];

						list.splice(newIndex, 0, movedItem);

						this.sepcifications.splice(
							0,
							this.sepcifications.length,
							...list
						);

						await this.saveSortOrder();
					},
				});
			});
        },
        async saveSortOrder() {
			const ids = this.sepcifications.map(
				(item) => item.id
			);

			try {
				await updateCustomerAttributesSort(
					this.$route.params.id,
					ids
				);

				this.$message.success(
					this.$t(
						"productSpecification.sortingSaveSuccess"
					)
				);
			} catch (error) {
				this.rollbackOrder();

				this.$message.error(
					this.$t(
						"productSpecification.sortingSaveFail"
					)
				);
			}
		},

		rollbackOrder() {
			this.sepcifications.splice(
				0,
				this.sepcifications.length,
				...this.originOrder
			);
		},

        // 点击添加规格弹出框
		handleAddDialogForm() {
			this.addDialogFormVisible = true;
		},

        // 取消添加
		handleAddCancel() {
			this.addDialogFormVisible = false;
		},

        //确定添加更新规格列表
		handleUpdateSpecification() {
			this.$emit("handle-update-specification");
			// 重新初始化拖拽功能
			this.$nextTick(() => {
				this.initRowDrag();
			});
		},

        // 编辑规格
		async handleEditDialogForm(index, row) {
			try {
				const { data } = await getCustomerAttributesDetails(this.$route.params.id, row.id);
				this.editDialogForm.name = data.name;
				this.editDialogForm.id = data.id;
				this.editDialogForm.options = data.options;
				this.editDialogForm.index = index;
				this.editDialogFormVisible = true;
			} catch (error) {
				this.$message.error(error); // 弹出错误提示
			}
		},

        // 取消编辑
		handleEditCancel() {
			this.editDialogFormVisible = false;
		},

        // 编辑确定编辑
		async handleEditConfirm() {
			this.$refs.editDialogForm.validate(async (valid) => {
				if (valid) {
					try {
						await putCustomerAttributesUpdate(this.$route.params.id, this.editDialogForm.id, this.editDialogForm);
						this.sepcifications[this.editDialogForm.index].name = this.editDialogForm.name;
						this.$message.success(this.$t("productSpecification.editedSuccessfully")); // 弹出成功提示
						this.editDialogFormVisible = false;
					} catch (error) {
						this.$message.error(error); // 弹出错误提示
					}
				} else {
					this.$message.error(this.$t("productSpecification.errorMessage")); // 弹出错误提示
					return false;
				}
			});
		},

        // 编辑删除options
		handleEditDeleteOptions(index) {
			this.editDialogForm.options.splice(index, 1);
		},

        // 编辑添加options弹出框
		handleEditAddOptions() {
			this.editAddOptionsFormVisible = true;
		},

        // 编辑取消添加options
		handleEditAddOptionsCancel() {
			this.editAddOptionsFormVisible = false;
			this.editOptionsName = "";
		},

        // 编辑确定添加options
		handleEditAddOptionsConfirm() {
			if (!this.editOptionsName) {
				this.$message.error(this.$t("productSpecification.enterAttributeName"));
				return;
			}
			this.editDialogForm.options.push({ name: this.editOptionsName });
			this.editOptionsName = "";
			this.editAddOptionsFormVisible = false;
		},

		// 删除
		async handleDelete(index, row) {
			const result = await this.$confirm(this.$t("productSpecification.sureDelete"), this.$t("productSpecification.hint"), {
				confirmButtonText: this.$t("common.sure"),
				cancelButtonText: this.$t("common.cancel"),
				type: "warning",
			});
			if (result == "confirm") {
				try {
					await deleteCustomerAttributes(this.$route.params.id, row.id);
					this.sepcifications.splice(index, 1);
					this.$message.success(this.$t("productSpecification.successfullyDeleted")); // 弹出成功提示
				} catch (error) {
					this.$message.error(error); // 弹出错误提示
				}
			}
		},
	},};
</script>

<style>
.el-dialog__body {
	padding: 14px 30px !important;
}

.table-caption {
	display: flex;
	justify-content: flex-end;
	padding-top: 5px;
}

.drag-handle {
	display: flex;
	align-items: center;
	cursor: move;
	user-select: none;
}

.drag-handle i {
	font-size: 16px;
	color: #909399;
}
</style>